// @flow
import _ from 'lodash';
import { store } from 'src/stores/store';
import { B2B_LIMIT_RELEASE_DATE, SHOPIFY_MARKET_RELEASE_DATE } from 'src/constants/subscription';
/**
 * Check if is freemium plan
 *
 * @param  {string} selectedPlan   selected plan
 * @return {boolean}
 */
export function isFreemiumPlan(tenantApp: Object) {
  const { selectedPlan = '' } = tenantApp;

  return selectedPlan.includes('freemium');
}

/**
 * Get percent
 * @param {*} current
 * @param {*} total
 * @returns
 */
export function displayPercentage(current, total) {
  let percentage = (current / total) * 100;
  let formattedPercentage;

  if (Number.isInteger(percentage)) {
    formattedPercentage = percentage + '%';
  } else {
    formattedPercentage = percentage.toFixed(2);
    formattedPercentage = parseFloat(formattedPercentage).toString() + '%';
  }
  return formattedPercentage;
}

/**
 * Check store has limit to sub B2B or not
 */
export function hasLimitB2BWithPackage() {
  // Always enable for staging
  if (process.env.REACT_APP_ENV === 'staging') {
    return true;
  }
  const currentState = store.getState();
  const recentInstalledAt = _.get(currentState, `oauth.tenantApp.recentInstalledAt`, 0);

  return recentInstalledAt > B2B_LIMIT_RELEASE_DATE;
}

export function hasLimitShopifyMarketWithPackage(
  selectedPlan = '',
  releaseDate = SHOPIFY_MARKET_RELEASE_DATE
) {
  // For staging release date will earler than prod 5 days
  if (process.env.REACT_APP_ENV === 'staging') {
    releaseDate = releaseDate - 5 * 24 * 60 * 60;
  }
  const currentState = store.getState();
  const recentInstalledAt = _.get(currentState, `oauth.tenantApp.recentInstalledAt`, 0);
  return recentInstalledAt > releaseDate && selectedPlan.includes('free');
}

export const filterShopifyMarketFeatures = ({ features, dataByFeatures }) => {
  const currentState = store.getState();
  const selectedPlan = _.get(currentState, `oauth.tenantApp.selectedPlan`, '');

  if (hasLimitShopifyMarketWithPackage(selectedPlan)) {
    if (dataByFeatures && !_.isEmpty(dataByFeatures['globalSales'])) {
      // For previous global sales, we only show content01 ~ multiple language
      dataByFeatures['globalSales'] = dataByFeatures['globalSales'].filter(item =>
        item.content.includes('Content01')
      );
    }

    if (features) {
      features = features.filter(item => !item.includes('feature_shopify_market'));
    }
  }

  return !_.isEmpty(features) ? features : dataByFeatures;
};

export const mappingPlanText = tenantApp => {
  const { selectedPlan = '' } = tenantApp;
  if (selectedPlan.includes('basic') || selectedPlan === '') {
    return 'AdminHTML.SubscriptionV4.Packages.basic.titlePlan';
  }
  if (selectedPlan.includes('essential')) {
    return 'AdminHTML.SubscriptionV4.Packages.essential.titlePlan';
  }
  if (selectedPlan.includes('professional')) {
    return 'AdminHTML.SubscriptionV4.Packages.professional.titlePlan';
  }
  if (selectedPlan.includes('freemium')) {
    return 'AdminHTML.SubscriptionV4.Packages.freemium.titlePlan';
  }

  return 'AdminHTML.SubscriptionV4.Packages.basic.titlePlan';
};

export const EXCLUDED_PLANS = [
  'affiliate',
  'cancelled',
  'staff',
  'closed',
  'plus_partner_sandbox',
  'trial',
  'frozen',
  'paused',
  'fraudulent',
  'partner_test',
  'dormant'
];
